import { render } from "./LottieError.vue?vue&type=template&id=c870b20e"
import script from "./LottieError.vue?vue&type=script&lang=js"
export * from "./LottieError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__